var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-runtime/~/core-js/library/modules/_has.js
// module id = 836
// module chunks = 2